import Lock01Icon from "@redotech/redo-icons/lock-01.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as styles from "./locked-track.module.css";

export const LockedTrack = memo(function LockedTrack({
  message,
}: {
  message: string;
}) {
  return (
    <Flex align="center" className={styles.container} gap="lg" p="xl">
      <Lock01Icon />
      <Text fontSize="xs" textColor="secondary">
        {message}
      </Text>
    </Flex>
  );
});
